import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter, Route, Routes
} from "react-router-dom";
import './share-target';
import AnimePage from './AnimePage';
import ContributePage from './ContributePage';
import ContributeAdmin from './ContributeAdmin';
import App from './App';
import DrivePage from './DrivePage';
import File from './File';
import Home from './Home';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Setup from './Setup';

function HomeOrApp() {
  const hasAccount = localStorage.getItem("disbox_account") !== null;
  const hasLegacyWebhook = localStorage.getItem("webhookUrl") !== null;
  if (!hasAccount && !hasLegacyWebhook) {
    return <Home />
  } else {
    return <App />
  }
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={'/web'}>
      <Routes>
        <Route path="" element={<HomeOrApp />}/>
        <Route path="home" element={<Home />}/>
        <Route path="setup" element={<Setup />} />
        <Route path="drive" element={<DrivePage />} />
        <Route path="file" element={<File />} />
        <Route path="anime" element={<AnimePage />} />
        <Route path="nonton" element={<AnimePage publicMode />} />
        <Route path="kontribusi" element={<ContributePage />} />
        <Route path="kontribusi-admin" element={<ContributeAdmin />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// Service worker (untuk "Bagikan ke Disbox" & download besar yang mengalir
// langsung ke disk). Hanya di hasil build, dan hanya kalau halaman dibuka
// lewat https atau localhost - browser tidak mengizinkan service worker di
// http://IP-biasa. Tidak menyimpan cache apa pun.
if ('serviceWorker' in navigator && window.isSecureContext && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/web/sw.js', { scope: '/web/' }).catch((error) => {
      console.warn('[Disbox] Service worker gagal didaftarkan:', error);
    });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
